export default __webpack_public_path__ + "static/media/FiraSans-Book.ede4ae3c.otf";